import jobDescription from './jobDescription';
import jobQualification from './jobQualification';
import jobProfessionalValues from './jobProfessionalValues';
import jobResponsibilities from './jobResponsibilities';
import communicationDomain from './communicationDomain';
import dutiesDescription from './dutiesDescription';
import competencies from './competenciesKnowledge';
import abilities from './competenciesAbility';
import skills from './competenciesSkill';
import courses from './competencyCourses';
import rules from './rules';
import powers from './powers';
import responsibilityHierarchy from './responsibilityHierarchy';
import jobProtectionClassification from './jobProtectionClassification';
import suppliers from './suppliers';

export default {
    jobDescription,
    jobQualification,
    jobProfessionalValues,
    jobResponsibilities,
    communicationDomain,
    dutiesDescription,
    competencies,
    abilities,
    skills,
    courses,
    rules,
    powers,
    responsibilityHierarchy,
    jobProtectionClassification,
    suppliers,
};
